import { render, staticRenderFns } from "./QuestionExerciseChapterPeriod.vue?vue&type=template&id=69c473fd&scoped=true&"
import script from "./QuestionExerciseChapterPeriod.vue?vue&type=script&lang=js&"
export * from "./QuestionExerciseChapterPeriod.vue?vue&type=script&lang=js&"
import style0 from "./QuestionExerciseChapterPeriod.vue?vue&type=style&index=0&id=69c473fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c473fd",
  null
  
)

export default component.exports